var map = {
	"./1.png": "f6da",
	"./2-grey.png": "b305",
	"./2.png": "dc38",
	"./3-center.png": "050d",
	"./3-left.png": "d46b",
	"./3-top.png": "4449",
	"./3.png": "e532",
	"./grey-stroke.png": "158e",
	"./left-grey.png": "0bab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f56";